import Reactotron from 'reactotron-react-js'

if (__DEV__) {
  Reactotron.configure().connect()
}
